import z from "zod";

const anthropicErrorTypeValues = ["NO_VALID_TEXT_CONTENT_RECEIVED", "NO_STRUCTURED_OUTPUT_RECEIVED"] as const;

const anthropicErrorTypeSchema = z.enum(anthropicErrorTypeValues);
const AnthropicErrorType = anthropicErrorTypeSchema.enum;
type AnthropicErrorType = z.infer<typeof anthropicErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type AnthropicErrors =
  | {
      errorType: typeof AnthropicErrorType.NO_VALID_TEXT_CONTENT_RECEIVED;
      data: {
        project_id: string;
      };
    }
  | {
      errorType: typeof AnthropicErrorType.NO_STRUCTURED_OUTPUT_RECEIVED;
      data: {
        model: string;
        stopReason: string | null;
      };
    };

export const anthropicErrorDetails: Record<AnthropicErrorType, ErrorDetails> = {
  [AnthropicErrorType.NO_VALID_TEXT_CONTENT_RECEIVED]: {
    sentryDescription: "No valid text content received from Anthropic",
  },
  [AnthropicErrorType.NO_STRUCTURED_OUTPUT_RECEIVED]: {
    sentryDescription: "Anthropic returned no structured output",
  },
};
